import { render, staticRenderFns } from "./C8M.vue?vue&type=template&id=3090a842&scoped=true"
import script from "./C8M.vue?vue&type=script&lang=js"
export * from "./C8M.vue?vue&type=script&lang=js"
import style0 from "./C8M.vue?vue&type=style&index=0&id=3090a842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3090a842",
  null
  
)

export default component.exports